"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultDiscountScope = exports.isRateEligibleForDiscount = void 0;
const ticketing_1 = require("../enums/ticketing");
const discount_validator_1 = require("./discount-validator");
const isRateEligibleForDiscount = (params) => {
    const { scope, rateId, discountRateMappings, isPayWhatYouCan, isAddOn, parentRateId } = params;
    if (isPayWhatYouCan) {
        return false;
    }
    if (isAddOn) {
        return false;
    }
    if (scope === ticketing_1.DiscountScope.FullOrder) {
        return false;
    }
    if (scope === ticketing_1.DiscountScope.PerTicketAllRates) {
        return true;
    }
    if (scope === ticketing_1.DiscountScope.PerTicketSpecificRates) {
        return (0, discount_validator_1.isTicketEligibleForSpecificRates)({ rateId, parentRateId }, discountRateMappings);
    }
    return false;
};
exports.isRateEligibleForDiscount = isRateEligibleForDiscount;
const getDefaultDiscountScope = (availableRatesCount) => {
    if (availableRatesCount <= 1) {
        return ticketing_1.DiscountScope.FullOrder;
    }
    return ticketing_1.DiscountScope.PerTicketAllRates;
};
exports.getDefaultDiscountScope = getDefaultDiscountScope;
